module.exports = __webpack_public_path__ + "startpage-746fed5a/westend61-a35a9358c4fa2bf61295e722995289d7.jpg";